module.exports = __webpack_public_path__ + "img/student-brief (4).1dd82ac6.png";